module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.c8e9599f.png";